"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = __importDefault(require("./lib/event"));
// 营销云系统默认数据，目前支持团队内系统使用，后期改造支持其他团队使用
var host = window.location.host;
var wwLogin = 'https://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js';
var MkVersionSDK = /** @class */ (function (_super) {
    __extends(MkVersionSDK, _super);
    function MkVersionSDK(config, callback, reload) {
        var _this = _super.call(this) || this;
        // 轮询间隔时间
        _this.timeArray = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
        // fetch 选项配置
        _this.params = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        _this.config = config;
        _this.oemUrl = _this.config.url;
        _this.url = "" + _this.config.versionUrl + '/json/version.json?random=' + Math.random();
        _this.callback = callback;
        _this.reload = reload;
        _this.init();
        return _this;
    }
    MkVersionSDK.prototype.init = function () {
        var _this = this;
        this.on('initFinished', function () {
            _this.ready(_this.callback);
        });
        // 初始化项目信息
        this.initProject();
    };
    MkVersionSDK.prototype.loadLongPolling = function (version) {
        var _this = this;
        var random = parseInt(Math.random() * 10 + '');
        setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var newTimestamp, oldTimestamp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchVersionInfo()];
                    case 1:
                        newTimestamp = (_a.sent()).timestamp;
                        oldTimestamp = version.timestamp;
                        if (newTimestamp !== oldTimestamp) {
                            // 触发重新加载
                            this.reload();
                        }
                        console.log('定时更新时间：', this.timeArray[random] * 1000);
                        return [2 /*return*/];
                }
            });
        }); }, this.timeArray[random] * 1000);
    };
    /**
     * 初始化应用版本信息
     */
    MkVersionSDK.prototype.initProject = function () {
        return __awaiter(this, void 0, void 0, function () {
            var version, res, iconUrl, title, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fetchVersionInfo()
                            // 获取 OEM 配置信息
                        ];
                    case 1:
                        version = _a.sent();
                        return [4 /*yield*/, this.fetchOEM(host)
                            // 营销云默认配置/OEM 无配置时默认数据/OEM 获取的配置数据（没有字段缺省）
                        ];
                    case 2:
                        res = _a.sent();
                        iconUrl = '';
                        title = '';
                        if (res.success) {
                            data = res.data;
                            // 这里查询不到代理商信息，后端返回  data: null
                            if (data !== null) {
                                this.config.oem = res.data;
                                // 这里必须要有一个默认值数据，防止用户不填写
                                iconUrl = res.data.icon || '';
                                title = res.data.productName;
                            }
                            else {
                                // 获取 OEM 信息配置失败, 查询不到相关数据
                                // 则默认为 dustess.com
                                // const DUSTESS = this.getDefaultDustessOEM(this.config.versionUrl)
                                // this.config.oem = DUSTESS
                                iconUrl = this.config.oem.icon;
                                title = this.config.oem.productName;
                            }
                        }
                        else {
                            // 获取 OEM 配置信息失败
                            // const DUSTESS = this.getDefaultDustessOEM(this.config.versionUrl)
                            // this.config.oem = DUSTESS
                            iconUrl = this.config.oem.icon;
                            title = this.config.oem.productName;
                        }
                        this.addLinkIco(iconUrl);
                        if (this.config.title !== false)
                            this.addTitle(title);
                        this.config.version = version;
                        // 先清楚之前的旧数据
                        window.localStorage.removeItem(version.name);
                        // 根据项目名称区分，存贮项目静态数据，以免在同域下，不同项目之间的缓存数据被覆盖
                        window.localStorage.setItem(version.name, JSON.stringify(version));
                        // 设置定时轮询
                        this.loadLongPolling(version);
                        this.emit('initFinished');
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MkVersionSDK.prototype.fetchVersionInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.fetch(this.url, __assign({}, this.params))];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MkVersionSDK.prototype.fetchOEM = function (domain) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.fetch(this.oemUrl + ("?domain=" + domain), __assign({}, this.params))];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MkVersionSDK.prototype.getDefaultDustessOEM = function (origin) {
        var DUSTESS = {
            name: '尘锋',
            productName: '尘锋营销中心',
            pcLoginMsg1: '尘锋信息 京ICP备17028758号',
            pcLoginMsg2: 'Copyright © 2019 北京尘锋信息技术有限公司 All Rights Reserved',
            url: origin,
            loginLogo: origin + "/img/loginLogo@2x.png",
            icon: origin + "/img/favicon.ico",
            menuLogo: origin + "/img/menuLogo@2x.png",
            menuLogoSmall: origin + "/img/menuLogoSmall@2x.png",
            crmUrl: '',
            collegeName: ''
        };
        return DUSTESS;
    };
    MkVersionSDK.prototype.addLinkIco = function (url) {
        // 此处应该有一个默认的 ico 地址
        var iconUrl = url || this.config.versionUrl + '/img/iconDefault.ico';
        // 此处的 ico 有可能是空，所以要设置默认的 ico 链接
        var $head = document.querySelector('head');
        var linkIcon = document.createElement('link');
        linkIcon.setAttribute('rel', 'icon');
        linkIcon.setAttribute('href', iconUrl);
        $head.appendChild(linkIcon);
    };
    MkVersionSDK.prototype.addTitle = function (name) {
        document.title = "" + name;
    };
    MkVersionSDK.prototype.loadWwLoginScript = function () {
        return new Promise(function (resolve, reject) {
            var ele = document.createElement('script');
            ele.type = 'text/javascript';
            ele.async = true;
            ele.onload = function () {
                resolve(true);
            };
            ele.onerror = function (error) {
                console.error('wwlogin-sdk loaded faily!');
                console.error(error);
                reject(false);
            };
            var linkEle = document.getElementsByTagName('script')[0];
            var parentNode = linkEle.parentNode;
            parentNode.insertBefore(ele, linkEle);
            ele.src = wwLogin;
        });
    };
    MkVersionSDK.prototype.ready = function (callback) {
        if (callback)
            callback();
    };
    return MkVersionSDK;
}(event_1.default));
exports.default = MkVersionSDK;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxzREFBc0M7QUFxRHRDLHFDQUFxQztBQUNyQyxJQUFNLElBQUksR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQTtBQUVqQyxJQUFNLE9BQU8sR0FBRyxxRUFBcUUsQ0FBQTtBQUVyRjtJQUEyQixnQ0FBWTtJQUNyQyxzQkFBYSxNQUFhLEVBQUUsUUFBbUIsRUFBRSxNQUFpQjtRQUFsRSxZQUNFLGlCQUFPLFNBT1I7UUFZRCxTQUFTO1FBQ1QsZUFBUyxHQUFHLENBQUMsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUE7UUFDcEQsYUFBYTtRQUNiLFlBQU0sR0FBRztZQUNQLE1BQU0sRUFBRSxLQUFLO1lBQ2IsT0FBTyxFQUFFO2dCQUNQLGNBQWMsRUFBRSxrQkFBa0I7YUFDbkM7U0FDRixDQUFBO1FBMUJDLEtBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO1FBQ3BCLEtBQUksQ0FBQyxNQUFNLEdBQUcsS0FBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUE7UUFDN0IsS0FBSSxDQUFDLEdBQUcsR0FBRyxLQUFHLEtBQUksQ0FBQyxNQUFNLENBQUMsVUFBWSxHQUFHLDRCQUE0QixHQUFHLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQTtRQUNyRixLQUFJLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQTtRQUN4QixLQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtRQUNwQixLQUFJLENBQUMsSUFBSSxFQUFFLENBQUE7O0lBQ2IsQ0FBQztJQXNCRCwyQkFBSSxHQUFKO1FBQUEsaUJBTUM7UUFMQyxJQUFJLENBQUMsRUFBRSxDQUFDLGNBQWMsRUFBRTtZQUN0QixLQUFJLENBQUMsS0FBSyxDQUFDLEtBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUMzQixDQUFDLENBQUMsQ0FBQTtRQUNGLFVBQVU7UUFDVixJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDcEIsQ0FBQztJQUNELHNDQUFlLEdBQWYsVUFBaUIsT0FBZ0I7UUFBakMsaUJBV0M7UUFWQyxJQUFNLE1BQU0sR0FBVyxRQUFRLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLENBQUMsQ0FBQTtRQUN4RCxXQUFXLENBQUM7Ozs7NEJBQzBCLHFCQUFNLElBQUksQ0FBQyxnQkFBZ0IsRUFBRSxFQUFBOzt3QkFBOUMsWUFBWSxHQUFLLENBQUEsU0FBNkIsQ0FBQSxVQUFsQzt3QkFDWixZQUFZLEdBQUssT0FBTyxVQUFaLENBQVk7d0JBQzNDLElBQUksWUFBWSxLQUFLLFlBQVksRUFBRTs0QkFDakMsU0FBUzs0QkFDVCxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUE7eUJBQ2Q7d0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxTQUFTLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQTs7OzthQUN0RCxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUE7SUFDbkMsQ0FBQztJQUNEOztPQUVHO0lBQ0csa0NBQVcsR0FBakI7Ozs7Ozs7d0JBRzZCLHFCQUFNLElBQUksQ0FBQyxnQkFBZ0IsRUFBRTs0QkFDdEQsY0FBYzswQkFEd0M7O3dCQUFoRCxPQUFPLEdBQVksU0FBNkI7d0JBRTFDLHFCQUFNLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDOzRCQUNyQywyQ0FBMkM7MEJBRE47O3dCQUEvQixHQUFHLEdBQUcsU0FBeUI7d0JBRWpDLE9BQU8sR0FBUSxFQUFFLENBQUE7d0JBQ2pCLEtBQUssR0FBRyxFQUFFLENBQUE7d0JBQ2QsSUFBSSxHQUFHLENBQUMsT0FBTyxFQUFFOzRCQUVQLElBQUksR0FBSyxHQUFHLEtBQVIsQ0FBUTs0QkFDcEIsK0JBQStCOzRCQUMvQixJQUFJLElBQUksS0FBSyxJQUFJLEVBQUU7Z0NBQ2pCLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUE7Z0NBQzFCLHdCQUF3QjtnQ0FDeEIsT0FBTyxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQTtnQ0FDN0IsS0FBSyxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFBOzZCQUM3QjtpQ0FBTTtnQ0FDTCwwQkFBMEI7Z0NBQzFCLG1CQUFtQjtnQ0FDbkIsb0VBQW9FO2dDQUNwRSw0QkFBNEI7Z0NBQzVCLE9BQU8sR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUE7Z0NBQzlCLEtBQUssR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUE7NkJBQ3BDO3lCQUNGOzZCQUFNOzRCQUNMLGdCQUFnQjs0QkFDaEIsb0VBQW9FOzRCQUNwRSw0QkFBNEI7NEJBQzVCLE9BQU8sR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUE7NEJBQzlCLEtBQUssR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUE7eUJBQ3BDO3dCQUNELElBQUksQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUE7d0JBQ3hCLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLEtBQUssS0FBSzs0QkFBRSxJQUFJLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFBO3dCQUNyRCxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7d0JBQzdCLFlBQVk7d0JBQ1osTUFBTSxDQUFDLFlBQVksQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFBO3dCQUM1QywwQ0FBMEM7d0JBQzFDLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFBO3dCQUNsRSxTQUFTO3dCQUNULElBQUksQ0FBQyxlQUFlLENBQUMsT0FBTyxDQUFDLENBQUE7d0JBQzdCLElBQUksQ0FBQyxJQUFJLENBQUMsY0FBYyxDQUFDLENBQUE7Ozs7d0JBRXpCLE9BQU8sQ0FBQyxHQUFHLENBQUMsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUVyQjtJQUVLLHVDQUFnQixHQUF0Qjs7Ozs0QkFDZSxxQkFBTSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLGVBQU8sSUFBSSxDQUFDLE1BQU0sRUFBRyxFQUFBOzRCQUF0RCxxQkFBSyxDQUFDLFNBQWdELENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBQTs0QkFBckUsc0JBQU8sU0FBOEQsRUFBQTs7OztLQUN0RTtJQUVLLCtCQUFRLEdBQWQsVUFBZ0IsTUFBYzs7Ozs0QkFDZixxQkFBTSxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxNQUFNLElBQUcsYUFBVyxNQUFRLENBQUEsZUFBTyxJQUFJLENBQUMsTUFBTSxFQUFHLEVBQUE7NEJBQS9FLHFCQUFLLENBQUMsU0FBeUUsQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFBOzRCQUE5RixzQkFBTyxTQUF1RixFQUFBOzs7O0tBQy9GO0lBRUQsMkNBQW9CLEdBQXBCLFVBQXNCLE1BQWM7UUFDbEMsSUFBTSxPQUFPLEdBQVE7WUFDbkIsSUFBSSxFQUFFLElBQUk7WUFDVixXQUFXLEVBQUUsUUFBUTtZQUNyQixXQUFXLEVBQUUscUJBQXFCO1lBQ2xDLFdBQVcsRUFBRSxtREFBbUQ7WUFDaEUsR0FBRyxFQUFFLE1BQU07WUFDWCxTQUFTLEVBQUssTUFBTSwwQkFBdUI7WUFDM0MsSUFBSSxFQUFLLE1BQU0scUJBQWtCO1lBQ2pDLFFBQVEsRUFBSyxNQUFNLHlCQUFzQjtZQUN6QyxhQUFhLEVBQUssTUFBTSw4QkFBMkI7WUFDbkQsTUFBTSxFQUFFLEVBQUU7WUFDVixXQUFXLEVBQUUsRUFBRTtTQUNoQixDQUFBO1FBQ0QsT0FBTyxPQUFPLENBQUE7SUFDaEIsQ0FBQztJQUVELGlDQUFVLEdBQVYsVUFBWSxHQUFXO1FBQ3JCLG9CQUFvQjtRQUNwQixJQUFJLE9BQU8sR0FBRyxHQUFHLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxVQUFVLEdBQUUsc0JBQXNCLENBQUE7UUFDbkUsZ0NBQWdDO1FBQ2hDLElBQU0sS0FBSyxHQUFRLFFBQVEsQ0FBQyxhQUFhLENBQUMsTUFBTSxDQUFDLENBQUE7UUFDakQsSUFBSSxRQUFRLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUM3QyxRQUFRLENBQUMsWUFBWSxDQUFDLEtBQUssRUFBRSxNQUFNLENBQUMsQ0FBQTtRQUNwQyxRQUFRLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxPQUFPLENBQUMsQ0FBQTtRQUN0QyxLQUFLLENBQUMsV0FBVyxDQUFDLFFBQVEsQ0FBQyxDQUFBO0lBQzdCLENBQUM7SUFDRCwrQkFBUSxHQUFSLFVBQVUsSUFBWTtRQUNwQixRQUFRLENBQUMsS0FBSyxHQUFHLEtBQUcsSUFBTSxDQUFBO0lBQzVCLENBQUM7SUFFRCx3Q0FBaUIsR0FBakI7UUFDRSxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUMsT0FBTyxFQUFFLE1BQU07WUFDakMsSUFBTSxHQUFHLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsQ0FBQTtZQUM1QyxHQUFHLENBQUMsSUFBSSxHQUFHLGlCQUFpQixDQUFBO1lBQzVCLEdBQUcsQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFBO1lBQ2hCLEdBQUcsQ0FBQyxNQUFNLEdBQUc7Z0JBQ1gsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFBO1lBQ2YsQ0FBQyxDQUFBO1lBQ0QsR0FBRyxDQUFDLE9BQU8sR0FBRyxVQUFDLEtBQUs7Z0JBQ2xCLE9BQU8sQ0FBQyxLQUFLLENBQUMsMkJBQTJCLENBQUMsQ0FBQTtnQkFDMUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQTtnQkFDcEIsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO1lBQ2YsQ0FBQyxDQUFBO1lBQ0QsSUFBTSxPQUFPLEdBQUcsUUFBUSxDQUFDLG9CQUFvQixDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO1lBQzFELElBQU0sVUFBVSxHQUFRLE9BQU8sQ0FBQyxVQUFVLENBQUE7WUFDMUMsVUFBVSxDQUFDLFlBQVksQ0FBQyxHQUFHLEVBQUUsT0FBTyxDQUFDLENBQUE7WUFDckMsR0FBRyxDQUFDLEdBQUcsR0FBRyxPQUFPLENBQUE7UUFDbkIsQ0FBQyxDQUFDLENBQUE7SUFDSixDQUFDO0lBRUQsNEJBQUssR0FBTCxVQUFPLFFBQW1CO1FBQ3hCLElBQUksUUFBUTtZQUFFLFFBQVEsRUFBRSxDQUFBO0lBQzFCLENBQUM7SUFDSCxtQkFBQztBQUFELENBQUMsQUFuS0QsQ0FBMkIsZUFBWSxHQW1LdEM7QUFFRCxrQkFBZSxZQUFZLENBQUEifQ==